import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { change } from 'redux-form';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { injectIntl, defineMessages } from 'react-intl';
import { withAccount } from '../../../../components/AccountContext';
import AssessmentTempComponent from './components/AssessmentTempComponent';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { buildEmailTemplatesData } from '../../../../utils/TemplateUtil';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { growlShape, intlShape } from '../../../../components/prop-types';
import { validationMessages } from '../../../../i18n/common';

const messages = defineMessages({
  behaviorInvalidError: {
    id: 'notification.behaviorInvalidError',
    defaultMessage: 'You need to select at least 3  Behaviour Dimensions',
  },
  distortionErrorRequired: {
    id: 'notification.distortionError1',
    defaultMessage: 'Please select Distortion option',
  },
  distortionErrorNotRequired: {
    id: 'notification.distortionError2',
    defaultMessage: 'Distortion is required only if a minimum of 3 Behaviour Dimensions are selected',
  },
  distortionErrorMax: {
    id: 'notification.distortionError3',
    defaultMessage: 'Only 1 Distortion option is allowed',
  },
});

const mapDispatchToProps = dispatch => ({
  onFieldChange: (form, field, value) => {
    dispatch(change(form, field, value));
  },
});

const buildValidationSchema = formatMessage => Yup.object().shape({
  title: Yup.string().required(formatMessage(validationMessages.required)),
  behavior: Yup.array()
    .ensure()
    .test(
      'behavior-is-valid',
      formatMessage(messages.behaviorInvalidError),
      behavior => behavior.length === 0 || behavior.length >= 3,
    ),
  distortion: Yup.array()
    .when(['behavior'], {
      is: behavior => behavior.length > 0,
      then: Yup.array()
        .min(1, formatMessage(messages.distortionErrorRequired))
        .max(1, formatMessage(messages.distortionErrorMax))
        .required(formatMessage(messages.distortionErrorRequired)),
      otherwise: Yup.array().max(0, formatMessage(messages.distortionErrorNotRequired)),
    }),
});

class AssessmentTempNew extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleCancle = this.handleCancle.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  handleCancle() {
    const { history, currentAccount } = this.props;
    history.push(`/accounts/${currentAccount}/assessments/templates`);
  }

  async handleCreate(formValues) {
    const {
      currentAccount,
      data: { account },
      history,
      growl,
      addTemp,
    } = this.props;
    const {
      title, interest, behavior, cognitive, distortion,
    } = formValues;
    const listbehavior = behavior ? behavior.map(value => value.name) : [];
    const listDistortion = distortion ? distortion.map(value => value.name) : [];
    const listcognitive = cognitive ? cognitive.map(value => value.name) : [];
    const { interestsSection } = account.assessmentSections;
    const interestsList = interestsSection.dimensions.map(interestDim => interestDim.name);
    const {
      feedbackTemplateId, inviteTemplateId, reminderTemplateId, thankYouTemplateId,
    } = buildEmailTemplatesData(
      formValues,
    );

    const AssessmentTempValues = {
      accountId: currentAccount,
      title,
      feedbackTemplateId,
      inviteTemplateId,
      reminderTemplateId,
      thankYouTemplateId,
      cognitiveDimensions: listcognitive,
      behaviorDimensions: [...listbehavior, ...listDistortion],
      interestsDimensions: (interest && interest.length > 0) ? interestsList : [],
    };
    try {
      const result = await addTemp({
        variables: {
          input: AssessmentTempValues,
        },
      });

      const assessmentTempId = result.data.createAssessmentTemplate.template.id;
      const redirectUrl = `/accounts/${currentAccount}/assessments/templates/${assessmentTempId}`;
      history.push(redirectUrl);
      return Promise.resolve();
    } catch (graphqlResponse) {
      growlErrors(growl, graphqlResponse);
      return Promise.reject();
    }
  }

  render() {
    const {
      data,
      initialValues,
      intl: { formatMessage },
    } = this.props;
    const validationSchema = buildValidationSchema(formatMessage);
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, formikBag) => {
                const { resetForm } = formikBag;
                this.handleCreate(values);
                resetForm();
              }}
              render={formProps => (
                <AssessmentTempComponent
                  formProps={formProps}
                  handleCancle={this.handleCancle}
                  handleCreate={this.handleCreate}
                  params={this.state}
                  data={data}
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

AssessmentTempNew.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  addTemp: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: growlShape.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = () => {
  // this is for communication templates
  const initialValues = {
    inviteTemplateId: -1,
    thankYouTemplateId: -1,
    reminderTemplateId: -1,
    feedbackTemplateId: -1,
    title: '',
  };
  return {
    initialValues,
  };
};

const assessmentTempGraphql = injectIntl(withGrowl(withRouter(AssessmentTempNew)));
export default withAccount(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(assessmentTempGraphql),
);
